import {
  GETMANUALDEPOSITLIST_SUCCESS,
  GETMANUALDEPOSITLIST_FAILED,
  RESET_GETMANUALDEPOSITLIST,
  LOADING_GETMANUALDEPOSITLIST,
  NETWORK_ERROR_GETMANUALDEPOSITLIST,
} from "../types/index";

const initialState = {
  isLoading: false,
  success: false,
  network: false,
  failed: false,
  data: {},
  message: "",
  networkError: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_GETMANUALDEPOSITLIST:
      return {
        ...state,
        isLoading: true,
        success: false,
        failed: false,
        network: false,
        data: {},
        message: "",
        networkError: "",
      };
    case GETMANUALDEPOSITLIST_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: true,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case GETMANUALDEPOSITLIST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        failed: false,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case NETWORK_ERROR_GETMANUALDEPOSITLIST:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: false,
        network: true,
        data: {},
        message: "",
        networkError: "",
      };
    case RESET_GETMANUALDEPOSITLIST:
      return (state = initialState);
    default:
      return state;
  }
};
